import { ref as g, computed as x, watch as C, openBlock as o, createBlock as S, Teleport as I, unref as d, createElementBlock as l, mergeProps as B, createElementVNode as s, Fragment as _, renderList as y, withDirectives as E, vShow as G, toDisplayString as f, createCommentVNode as b } from "vue";
const A = {
  style: { fill: "white" },
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, R = /* @__PURE__ */ s("path", { d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l105.4 105.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H416C433.7 224 447.1 238.3 447.1 256z" }, null, -1), z = [
  R
], H = ["src"], M = {
  style: { fill: "white" },
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, O = /* @__PURE__ */ s("path", { d: "M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z" }, null, -1), P = [
  O
], D = {
  style: { fill: "white" },
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, N = /* @__PURE__ */ s("path", { d: "M376.6 427.5c11.31 13.58 9.484 33.75-4.094 45.06c-5.984 4.984-13.25 7.422-20.47 7.422c-9.172 0-18.27-3.922-24.59-11.52L192 305.1l-135.4 162.5c-6.328 7.594-15.42 11.52-24.59 11.52c-7.219 0-14.48-2.438-20.47-7.422c-13.58-11.31-15.41-31.48-4.094-45.06l142.9-171.5L7.422 84.5C-3.891 70.92-2.063 50.75 11.52 39.44c13.56-11.34 33.73-9.516 45.06 4.094L192 206l135.4-162.5c11.3-13.58 31.48-15.42 45.06-4.094c13.58 11.31 15.41 31.48 4.094 45.06l-142.9 171.5L376.6 427.5z" }, null, -1), V = [
  N
], $ = { id: "photoIndexInfo" }, q = { class: "photo-preview-wrapper" }, F = ["onClick"], T = ["src"], K = {
  __name: "Gallery",
  props: {
    imgSrcList: {
      type: Array,
      required: !0
    }
  },
  emits: [
    "swappedRight",
    "swappedLeft",
    "onClose",
    "onGalleryOpen"
  ],
  setup(r, { expose: m, emit: i }) {
    const h = r;
    let t = g(0), c = g(!1);
    x(() => h.imgSrcList[t.value]);
    const w = (e) => {
      e.key === "ArrowRight" && p(), e.key === "ArrowLeft" && v(), e.key === "Escape" && u();
    };
    C(c, (e) => {
      e ? window.addEventListener("keyup", w) : window.removeEventListener("keyup", w);
    });
    const L = (e = 0) => {
      i("onGalleryOpen"), t.value = e, c.value = !0;
    }, u = () => {
      i("onClose"), c.value = !1;
    }, p = () => {
      h.imgSrcList.length !== t.value + 1 && (t.value = t.value + 1, i("swappedRight"));
    }, v = () => {
      t.value !== 0 && (t.value = t.value - 1, i("swappedLeft"));
    }, k = (e) => {
      t.value = e;
    };
    return m({ openGallery: L }), (e, U) => (o(), S(I, { to: "body" }, [
      d(c) ? (o(), l("div", B({ key: 0 }, e.$attrs, { class: "gallery-wrapper" }), [
        s("div", {
          class: "arrow-button",
          onClick: v,
          id: "leftArrow"
        }, [
          (o(), l("svg", A, z))
        ]),
        (o(!0), l(_, null, y(r.imgSrcList, (n, a) => (o(), l("div", {
          class: "gallery",
          key: n
        }, [
          E(s("img", { src: n }, null, 8, H), [
            [G, a === d(t)]
          ])
        ]))), 128)),
        s("div", {
          class: "arrow-button",
          onClick: p,
          id: "rightArrow"
        }, [
          (o(), l("svg", M, P))
        ]),
        s("div", {
          id: "closeButton",
          onClick: u
        }, [
          (o(), l("svg", D, V))
        ]),
        s("div", $, f(d(t) + 1) + "/" + f(r.imgSrcList.length), 1),
        s("div", q, [
          (o(!0), l(_, null, y(r.imgSrcList, (n, a) => (o(), l("div", {
            class: "photo-preview-box",
            key: n,
            onClick: (j) => k(a)
          }, [
            s("img", {
              src: n,
              width: "50",
              height: "50"
            }, null, 8, T)
          ], 8, F))), 128))
        ])
      ], 16)) : b("", !0)
    ]));
  }
};
export {
  K as default
};
